import { FC, ReactNode } from 'react';
import { Accordion, Badge, Divider, Group, Stack, Text } from '@mantine/core';

import { RouterOutput } from '../../../services/trpc';
import { NotificationItem } from './notification-item';

type Notification = RouterOutput['notifications']['list'][number];

type Props = {
  label: string;
  value: string;
  notifications: Notification[];
  onMarkAsSeen?: (id: string) => void;
  onMarkAsActive?: (id: string) => void;
  footer?: ReactNode;
};

export const NotificationGroup: FC<Props> = ({
  label,
  value,
  notifications,
  onMarkAsSeen,
  onMarkAsActive,
  footer,
}) => {
  if (notifications.length === 0) return null;

  return (
    <Accordion.Item value={value}>
      <Accordion.Control>
        <Group gap="sm">
          <Text fw={600}>{label}</Text>
          <Badge size="sm" variant="light">
            {notifications.length}
          </Badge>
        </Group>
      </Accordion.Control>
      <Accordion.Panel>
        <Stack gap={0}>
          {notifications.map((notification, index) => (
            <div key={notification.id}>
              <NotificationItem
                notification={notification}
                onMarkAsSeen={onMarkAsSeen}
                onMarkAsActive={onMarkAsActive}
              />
              {index < notifications.length - 1 && <Divider />}
            </div>
          ))}
          {footer}
        </Stack>
      </Accordion.Panel>
    </Accordion.Item>
  );
};
